{
  "version": 1,
  "asset_id": "ec235ed1-c4b2-430c-a90f-34fceb472985",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/ec235ed1-c4b2-430c-a90f-34fceb472985/g23.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/ec235ed1-c4b2-430c-a90f-34fceb472985/g23.jpg",
  "original_filename": "g23.jpg",
  "size": 57625,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
